module.exports = __webpack_public_path__ + "img/VideoButtonActivity.39a4e9b2.png";